export enum EmailActionTypes {
  Reply = 'reply',
  ReplyAll = 'replyAll',
  Forward = 'forward',
}
